import filter from 'lodash/filter';

const normalizeInput = (value: string, ignores?: string[]): string => {
  let input = value?.toString().toLowerCase();
  if (ignores && input) {
    ignores.forEach(item => {
      input = input.replace(item, '');
    });
  }
  return input;
};

const handleSearch = (list: any[], value: string, ignores?: string[]) => {
  const result = filter(list, li => {
    for (const key in li) {
      if (
        normalizeInput(li[key], ignores)?.startsWith(
          normalizeInput(value, ignores)
        )
      )
        return true;
    }
    return false;
  });
  return result;
};

export default handleSearch;
